export default "__VITE_ASSET__Di6ifHiv__"